








































































































import {
  Button,
  Cell,
  Image,
  List,
  PullRefresh,
  Popup,
  Calendar,
  Picker,
  DatetimePicker,
  Empty
} from "vant";
import { Component, Vue } from "vue-property-decorator";
import CustomSelect from "@/views/create-account/components/CustomSelect.vue";
import moment from "moment/moment";

@Component({
  components: {
    CustomSelect,
    [Button.name]: Button,
    [Popup.name]: Popup,
    [PullRefresh.name]: PullRefresh,
    [List.name]: List,
    [Cell.name]: Cell,
    [Calendar.name]: Calendar,
    [Picker.name]: Picker,
    [DatetimePicker.name]: DatetimePicker,
    [Empty.name]: Empty,
    [Image.name]: Image
  }
})

export default class OperationRecords extends Vue {
  refreshing = false;
  loading = false;
  finished = false;
  showModulesPicker = false;
  showStartTimePicker = false;
  showEndTimePicker = false;
  minDate = new Date("2000-01-01");
  recordList = [];
  currentPage = 1;
  startDate = new Date();
  endDate = new Date();
  startTime = moment(new Date()).format("YYYY-MM-DD");
  endTime = moment(new Date()).format("YYYY-MM-DD");
  tempStartTime = "";
  isStartAndEndTimeChange = false;
  selectModule = "";
  selectModuleName = "全部";
  typeList = [
    "全部",
    "登录",
    "登出",
    "账号操作",
    "下单",
    "撤单",
	"策略执行配置"
    // "平仓"
  ];

  get startAndEndTimeTitle(): string {
    if (!this.isStartAndEndTimeChange) {
      return "开始 - 结束时间";
    }
    return (
      moment(this.startTime).format("YYYYMMDD") +
      " - " +
      moment(this.endTime).format("YYYYMMDD")
    );
  }

  get maxDate() {
    return new Date();
  }

  handleModulesPickerConfirm(item: string) {
    this.showModulesPicker = false;
    this.selectModuleName = item;
    const dict = {
      "全部": "",
      "登录": "login",
      "登出": "logout",
      "账号操作": "account",
      "下单": "businessOrder_order",
      "撤单": "businessOrder_cancel",
	  "策略执行配置": "strategyConfig"
      // "平仓": "business_close"
    };
    this.selectModule = dict[item];
    this.currentPage = 1;
    this.recordList = [];
    this.onRefresh();
  }

  handleStartTimeConfirm(time: string) {
    this.showStartTimePicker = false;
    this.showEndTimePicker = true;
    this.tempStartTime = moment(time).format(this.dateFormatString());
  }

  handleEndTimeConfirm(time: string) {
    this.showEndTimePicker = false;
    this.startTime = this.tempStartTime;
    this.tempStartTime = "";
    this.endTime = moment(time).format(this.dateFormatString());
    this.isStartAndEndTimeChange = true;
    this.recordList = [];
    this.currentPage = 1;
    this.onRefresh();
  }

  handleStartTimeCancel() {
    this.showStartTimePicker = false;
  }

  handleEndTimeCancel() {
    this.tempStartTime = "";
    this.showEndTimePicker = false;
  }

  dateFormatString(): string {
    return "YYYY-MM-DD";
  }

  datePickerFormatter(type, val) {
    if (type === "year") {
      return val + "年";
    }
    if (type === "month") {
      return val + "月";
    }
    if (type === "day") {
      return val + "日";
    }
    if (type === "hour") {
      return val + "时";
    }
    return val;
  }

  getDate(dateString): string {
    return moment(dateString).format("MM月DD日 HH:mm:ss");
  }

  onLoad() {
    const param = {
      start_time: this.startTime + " 00:00:00",
      end_time: this.endTime + " 23:59:59",
      page_size: 20,
      page: this.currentPage,
      action_module: this.selectModule
    };
    this.loading = true;
    (this as any).$apis
      .recordList(param)
      .then(res => {
        if (this.refreshing) {
          this.recordList = [];
        }
        this.recordList = this.recordList.concat(res.data);
        this.currentPage = res.current_page + 1;
        this.refreshing = false;
        this.loading = false;
        if (res.current_page == res.last_page) {
          this.finished = true;
        }
      })
      .catch(e => {
        
      });
  }

  onRefresh() {
    this.finished = false;
    this.currentPage = 1;
    this.onLoad();
  }
};

